const awsconfig = {
  "aws_project_region": "eu-west-1",
  "aws_cognito_region": "eu-west-1",
  "aws_user_pools_id": "eu-west-1_FNruSIPyV",
  "aws_user_pools_web_client_id": "3cheo1qc9g67a5lg8s8128frdf",
  "oauth": {},
  "aws_cognito_username_attributes": ["email"],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": ["email"],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": ["SMS"],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": ["email"],
  "API": {
    "REST": {
      "PsychicLampAPI": {
        "endpoint": "https://17igbr2mm5.execute-api.eu-west-1.amazonaws.com/dev",
        "region": "eu-west-1"
      }
    }
  }
};

export default awsconfig;